"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));
var _alloyReactToggle = _interopRequireDefault(require("@adsk/alloy-react-toggle"));
var _alloyReactTooltip = require("@adsk/alloy-react-tooltip");
var _i18n = require("../../../i18n");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SaveToggle = _ref => {
  let {
    className,
    checked,
    isQrp,
    onChange
  } = _ref;
  const handleChange = value => onChange({
    checked: value
  });
  return /*#__PURE__*/_react.default.createElement(StyledContainer, {
    className: className,
    $isQrp: isQrp
  }, isQrp ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledToggleHeader, null), /*#__PURE__*/_react.default.createElement(StyledToggle, {
    checked: checked,
    onChange: handleChange,
    "data-testid": "save-toggle"
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledToggle, {
    checked: checked,
    onChange: handleChange,
    "data-testid": "save-toggle"
  }), /*#__PURE__*/_react.default.createElement(StyledToggleHeader, null)));
};
const SaveToggleHeader = _ref2 => {
  let {
    className
  } = _ref2;
  const {
    T
  } = (0, _i18n.useTranslation)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement(StyledTitle, null, T.translate('saveToFiles.title')), /*#__PURE__*/_react.default.createElement(StyledInfoPopover, {
    message: T.translate('tooltips.infoPopover'),
    placement: "top",
    size: 16
  }));
};
const StyledContainer = _styledComponents.default.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
  ${_ref3 => {
  let {
    $isQrp
  } = _ref3;
  return $isQrp && 'justify-content: space-between;';
}}
`;
const StyledToggleHeader = (0, _styledComponents.default)(SaveToggleHeader)`
  display: flex;
  align-items: center;
  gap: 4px;
`;
const StyledToggle = (0, _styledComponents.default)(_alloyReactToggle.default)`
  box-sizing: border-box;
  flex-shrink: 0;
`;
const StyledTitle = _styledComponents.default.span`
  color: #3c3c3c;
  flex-shrink: 0;
  ${{
  ..._alloyReactTheme.default.typography.labelMedium
}}
`;
const StyledInfoPopover = (0, _styledComponents.default)(_alloyReactTooltip.InfoPopover)`
  flex-shrink: 0;
  line-height: 0;
`;
SaveToggleHeader.propTypes = {
  className: _propTypes.default.string
};
SaveToggle.propTypes = {
  className: _propTypes.default.string,
  checked: _propTypes.default.bool.isRequired,
  isQrp: _propTypes.default.bool.isRequired,
  onChange: _propTypes.default.func.isRequired
};
var _default = exports.default = SaveToggle;